import React, { Fragment, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const FAQ = () => {
    const { t } = useTranslation()

    return (
        <div className="staticPageWrapper p-5 text-left">
            <div
                className="faq"
                dangerouslySetInnerHTML={{
                    __html: t('faq_page'),
                }}
            ></div>
        </div>
    )
}

export default FAQ
